var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comment"},[_c('div',{staticClass:"comment-author"},[_vm._t("author")],2),_c('div',{staticClass:"comment-content"},[_vm._t("content")],2),_c('div',{staticClass:"comment-actions"},[_vm._t("actions")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }